function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8 8"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7.71 6.29L5.41 4l2.3-2.29A1 1 0 006.29.29L4 2.59 1.71.29A1 1 0 10.29 1.71L2.59 4 .29 6.29a1 1 0 101.42 1.42L4 5.41l2.29 2.3a1 1 0 001.42-1.42z"
})));